import { EnvironmentModel, EnvName } from '@fb/models';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment: EnvironmentModel = {
  shortName: 'pt',
  production: false,
  useMocks: false,
  envName: EnvName.DEV,
  apiHost:
    (window as any).apiHost || 'https://api-dev-team.redcore.group/api/v1/',
  wssHost:
    (window as any).wssHost || 'wss://api-dev-team.redcore.group/api/v1/',
  lmsHost: (window as any).lmsHost || 'https://dev-lms.redcore.group/',
  assetsUrl: 'https://fb-dev-team.redcore.group',
  financeConfluenceLink: 'https://wiki.time2go.tech/display/WORLD/Locations',
  slackTeamId: 'T01FZLAFN9Z',
  growthBook: {
    apiHost: 'https://api-growthbook-team.redcore.group',
    clientKey: 'sdk-R1pkWzJeAXV0dyY',
  },
  blockAiChat: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
